import { DocumentType } from '@superbet-group/web.lib.config';

import User from '@core/models/user/User';
import { isIdCardVerificationPending } from '@models/user/UserDataService';

import {
    GeneralEventDto,
    verifyIdentityExpIds,
    verifyIdentityEntrypoints,
    EntryEventDto,
    IntroEventDto,
    SelectDocumentEventDto,
    ImageUploadEventDto,
    PhotoDeliveryMethods,
    ImageUploadSecondEventPayload,
    EventParamsDto,
} from '../types';

export function generateGeneralPayload(params : EventParamsDto): GeneralEventDto {
    return {
        darklyExpId: params.kycVersion ? verifyIdentityExpIds.New : verifyIdentityExpIds.Old,
        kycStatus: getKycStatus(params.user).toString(),
    };
}

function getKycStatus(user: User): boolean | 'pending' {
    return user.isVerifiedIdCard || (isIdCardVerificationPending(user) ? 'pending' : false);
}

function hasCompletedRegistration(user: User): boolean {
    return !!user.phone;
}

export function generateEntryPayload(
    generalPayload: GeneralEventDto,
    source: verifyIdentityEntrypoints = verifyIdentityEntrypoints.Upload,
    user: User,
): EntryEventDto {
    return {
        ...generalPayload,
        ...{ completedRegistration: hasCompletedRegistration(user) },
        ...{ source },
    };
}

export function generateIntroPayload(
    generalPayload: GeneralEventDto,
    user: User,
): IntroEventDto {
    return {
        ...generalPayload,
        ...{ completedRegistration: hasCompletedRegistration(user) },
    };
}

export function generateSelectDocumentPayload(
    generalPayload: GeneralEventDto,
    type: DocumentType = DocumentType.AdditionalDocument,
    user: User,
): SelectDocumentEventDto {
    return {
        ...generalPayload,
        ...{ completedRegistration: hasCompletedRegistration(user) },
        ...{ type },
    };
}

export function generateImageUploadPayload(
    generalPayload: GeneralEventDto,
    type: DocumentType = DocumentType.AdditionalDocument,
    method: PhotoDeliveryMethods = PhotoDeliveryMethods.Upload,
): ImageUploadEventDto {
    return {
        ...generalPayload,
        ...{ type },
        ...{ method },
    };
}

export function generateImageUploadSecondStepStartedPayload(
    generalPayload: GeneralEventDto,
    type : DocumentType = DocumentType.Id,
): ImageUploadSecondEventPayload {
    return {
        ...generalPayload,
        ...{ type },
    };
}
